import React from "react";
import { Input } from "@progress/kendo-react-inputs";
import { icon } from "../../../config";

/**
 * SearchInput component for rendering a search input with icon
 * @author Muskan Thakur
 */
const SearchInput = ({ placeholder, value, onChange, onKeyDown }) => {
  return (
    <div className='smart-chip-search-container'>
      <span className='smart-chip-search-icon'>{icon.SEARCH}</span>
      <div className='smart-chip-search-input'>
        <Input placeholder={placeholder} value={value} onChange={onChange} autoFocus={true} onKeyDown={onKeyDown} />
      </div>
    </div>
  );
};

export default React.memo(SearchInput);
